const SubscriptionEvents = {
  // Checkout & Update Payment
  CHECKOUT_VIEWED: 'subscription_checkout_viewed',
  UPDATE_PAYMENT_VIEWED: 'subscription_update_payment_viewed',
  PAYMENT_METHOD_SELECTED: 'subscription_payment_method_selected',
  PAY_CLICK: 'subscription_pay_click',
  PAYMENT_SUCCESS: 'subscription_payment_success',
  UPDATE_PAYMENT_SUCCESS: 'subscription_update_payment_success',
  PAYMENT_FAILURE: 'subscription_payment_failure',

  // Account Settings
  SETTINGS_VIEWED: 'subscription_settings_viewed',
  CANCEL_CLICK: 'subscription_cancel_click',
  CANCELLATION_CONFIRMED: 'subscription_cancellation_confirmed',
  RENEW_CLICK: 'subscription_renew_click',
  RENEW_SUCCESS: 'subscription_renew_success',
  RENEW_FAILURE: 'subscription_renew_failure',
  REACTIVATE_CLICK: 'subscription_reactivate_click',
  REACTIVATE_SUCCESS: 'subscription_reactivate_success',
  REACTIVATE_FAILURE: 'subscription_reactivate_failure',
  RETRY_PAYMENT_CLICK: 'subscription_retry_payment_click',
  PAUSE_OFFER_VIEWED: 'subscription_pause_offer_viewed',
  PAUSE_CLICK: 'subscription_pause_click',
  PAUSE_OFFER_DECLINED: 'subscription_pause_offer_declined',
  PAUSE_OFFER_DISMISSED: 'subscription_pause_offer_dismissed',
  PAUSE_SCHEDULED: 'subscription_pause_scheduled',
  PAUSE_FAILURE: 'subscription_pause_failure',
  PAUSE_RESUME_CLICK: 'subscription_pause_resume_click',
  PAUSE_RESUME_SUCCESS: 'subscription_pause_resume_success',
  PAUSE_RESUME_FAILURE: 'subscription_pause_resume_failure',
  PAYMENT_HISTORY_VIEWED: 'subscription_payment_history_viewed',
  INVOICE_DOWNLOAD_CLICK: 'subscription_invoice_download_click',
  INVOICE_DOWNLOAD_FAILED: 'subscription_invoice_download_failed',

  // Homepage Promo Banner
  PROMO_BANNER_IMPRESSION: 'subscription_promo_banner_impression',
  PROMO_BANNER_CTA_CLICK: 'subscription_promo_banner_cta_click',

  // My Purchases
  PURCHASES_TAB_VIEWED: 'subscription_purchases_tab_viewed',
  ITEM_DOWNLOAD_CLICK: 'subscription_item_download_click',

  // Item Page
  WIDGET_VISIBLE: 'subscription_widget_visible',
  ITEM_CTA_CLICK: 'subscription_item_cta_click',

  // Guest Checkout Flow
  GUEST_EMAIL_STEP_VIEWED: 'subscription_guest_email_step_viewed',
  GUEST_EMAIL_SUBMITTED: 'subscription_guest_email_submitted',
  GUEST_LOGIN_STEP_VIEWED: 'subscription_guest_login_step_viewed',
  GUEST_LOGIN_COMPLETED: 'subscription_guest_login_completed',
  GUEST_NOT_YOU_CLICKED: 'subscription_guest_not_you_clicked',
  GUEST_CREATE_ACCOUNT_STEP_VIEWED: 'subscription_guest_create_account_step_viewed',
  GUEST_CREATE_ACCOUNT_COMPLETED: 'subscription_guest_create_account_completed',

  // Listing Free-Filter Upsell Block
  UPSELL_BLOCK_IMPRESSION: 'subscription_upsell_block_impression',
  UPSELL_BLOCK_CTA_CLICK: 'subscription_upsell_block_cta_click',
  UPSELL_BLOCK_CARD_CLICK: 'subscription_upsell_block_card_click',
}

export default SubscriptionEvents
